import * as React from "react"

import { isNumber } from "../../../../../../util/Strings"

import UnavailableLink from "../UnavailableLink"

import CreatePerson from "./CreatePerson"
import PersonDetail from "./PersonDetail"

interface Props {
    attributes: Record<string, string>
    label: string
    linkParameters: string[]
}

export const PersonInternalLink = ({
    attributes,
    label,
    linkParameters,
}: Props): JSX.Element => {
    if (linkParameters.length === 2) {
        if (linkParameters[1] === "create") {
            // PERSON.CREATE => OPENS THE CREATE NEW PERSON PAGE
            return <CreatePerson attributes={attributes} label={label} />
        } else if (isNumber(linkParameters[1])) {
            // PERSON.[PERSONID] => OPENS THE GIVEN PERSON DETAIL PAGE
            // the old functionality just puts the label there
            // doesn't check for user existance
            return (
                <PersonDetail
                    attributes={attributes}
                    label={label}
                    personId={linkParameters[1]}
                />
            )
        }
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default PersonInternalLink
